import yup from 'utils/yup';

export const initialReportsByWeekTotalFormData = {
  date_range: undefined as any,
};

export const reportsByWeekTotalValidationSchema = yup.object().shape({
  date_range: yup.string().required(),
});
